module.exports = __webpack_public_path__ + "static/media/hifive.1a4b4ba1.png";